export default __webpack_public_path__ + "static/zonapro-bold-cf3f205ab6202fb8c2e75d2305021498.woff2";